/**
 * pdf.js safety options for every document Capture UI loads.
 *
 * isEvalSupported: false turns off pdf.js's compiled font path, which runs
 * attacker-controlled font data as JavaScript in pdf.js before 4.2.67
 * (CVE-2024-4367, GHSA-wgrm-67xf-hhpq). Capture UI renders PDFs uploaded by any
 * member and PDFs that arrive by email from outside senders, so every load must
 * set it. tests: utils/pdfSafety.test.js fails if a load omits it.
 *
 * PDF_DOCUMENT_OPTIONS is for react-pdf's <Document options>. It is one module
 * constant on purpose: react-pdf reloads the document whenever the options
 * object changes identity. Direct pdfjs getDocument calls write
 * isEvalSupported: false in their own parameter object.
 */
export const PDF_DOCUMENT_OPTIONS = { isEvalSupported: false };
